export const blockIconsPlacesRoomPreferences = (
	<span className='material-symbols-outlined'>room_preferences</span>
);
